const enableUIStrategy = action => ({ [action.name]: action.value });
const uiStrateguMap = {
  enable: enableUIStrategy,
};
const uiStrategy = ({ actions }) =>
  actions.reduce((acc, cur) => {
    const strategy = uiStrateguMap[cur.name];
    if (!strategy) return acc;
    return { ...acc, ...strategy(cur) };
  }, {});

export default uiStrategy;
